import * as z from 'zod'

import { DOG_LIABILITY_NXT_CONSTANTS } from '@flows/configs/dogLiabilityNxt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_DogLiabilityBasicDe } from '@flows/insurance/schemas'

const claimsOptionsFromSchema = schemaUtils.getEnumValuesFromPipelineSchema(
  BaseSchema_DogLiabilityBasicDe.shape.number_of_claims_in_last_5y
)
const dog_damages = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]:
        validators.createPreprocessedEnumNumberSchema(z.enum([...claimsOptionsFromSchema, '3'])),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_damages.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
        options: DOG_LIABILITY_NXT_CONSTANTS.claimsOptions,
      },
    ],
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
      valueToStepName: {
        '0': 'dog_insurance_cancelled',
        '1': 'dog_insurance_cancelled',
        '2': 'dog_insurance_cancelled',
        '3': 'failure',
      },
    },
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default dog_damages
